import { PlanCargoConceptoFacturacionService } from './../../../_services/plan-cargo-concepto-facturacion.service';
import { PlanCargoConceptoFacturacion } from './../../../_models/plan-cargo-concepto-facturacion';
import { NavService } from './../../../_services/_nav.service';
import { PlanCargoService } from './../../../_services/plan-cargo.service';
import { PlanCargo } from './../../../_models/plan-cargo';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-planes-cargos-detalle',
  templateUrl: './planes-cargos-detalle.component.html',
  styleUrls: ['./planes-cargos-detalle.component.css']
})
export class PlanesCargosDetalleComponent implements OnInit {

  planCargo: PlanCargo;
  planCargosConceptos: PlanCargoConceptoFacturacion[] = [];
  carInformacionInicial = true;

  colConceptos = [];


  constructor( private planCargoService: PlanCargoService,
                private planCargoConceptoFacturacionServicio: PlanCargoConceptoFacturacionService,
               private route: ActivatedRoute,
               private nav: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {

    this.colConceptos = [
      {
        field: 'nombreConceptoFacturacion',
        header: this.nav.buscarMensaje( 'PRODUCTOCONCEPTO.LBL_CONCEPTOFACTURACION' ),
        sort: false
      },
      { field: 'nombreConvenio', header: this.nav.buscarMensaje('PRODUCTOCONCEPTO.LBL_CONVENIO' ), sort: false, },
      { field: 'nombreTipoDatoConcepto', header: this.nav.buscarMensaje( 'PRODUCTOCONCEPTO.LBL_TIPODATO' ), sort: false },
      { field: 'valor', header: this.nav.buscarMensaje( 'PRODUCTOCONCEPTO.LBL_VALOR' ), sort: false },
      { field: 'nombreTipoIva', header: this.nav.buscarMensaje( 'PRODUCTOCONCEPTO.LBL_IVA' ), sort: false },
      { field: 'nombreTipoPago', header: this.nav.buscarMensaje( 'PRODUCTOCONCEPTO.LBL_FORMAPAGO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.planCargoService.obtenerPorId( params[ 'id' ] ),
        this.planCargoConceptoFacturacionServicio.listadoPorPlanCargo(params[ 'id' ])
      ).subscribe( ( [ planCargo, planCargoConceptoFacturacion] ) => {
        this.planCargo = planCargo;
        this.planCargosConceptos = planCargoConceptoFacturacion;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }

}
